import React from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { loginRequest } from 'redux/actions/actions'
import View from '../components/View'

class Login extends React.Component {

	render () {
		return <View {...this.props} />
	}
}

const mapDispatchToProps = (dispatch, props) => {

	return {
		dispatch,
		onSubmit: data => dispatch(loginRequest(data)).then(() => props.history.push('home'))
	}
}

export default connect(null, mapDispatchToProps)(reduxForm({
	form: 'login',
})(Login))



// WEBPACK FOOTER //
// ./src/routes/Login/containers/Login.js